import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=79a63aab&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=79a63aab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a63aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a63aab')) {
      api.createRecord('79a63aab', component.options)
    } else {
      api.reload('79a63aab', component.options)
    }
    module.hot.accept("./ChatMessage.vue?vue&type=template&id=79a63aab&scoped=true", function () {
      api.rerender('79a63aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat-components/ChatMessage.vue"
export default component.exports